import { HanaUseCaseKey } from 'src/types/hanaUseCases';

// Legacy keys remain in the wire type so cached user records and rolling
// deployments deserialize safely. The UI never offers a response-mode choice.
export const HANA_USE_CASE: Record<string, HanaUseCaseKey> = {
  BUSINESS_ASSISTANT: 'BUSINESS_ASSISTANT',
  PERSONAL_COMPANION: 'PERSONAL_COMPANION',
  PERSONAL_COMPANION_NSFW: 'PERSONAL_COMPANION_NSFW',
};

export const DEFAULT_HANA_USE_CASE = HANA_USE_CASE.BUSINESS_ASSISTANT;
